/**
 * Clientes con trabajo hecho y verificable.
 *
 * REGLA DE ESTE ARCHIVO: solo entra un cliente cuando el trabajo existe y se
 * puede comprobar. Nada de "trabajamos con las mejores marcas" ni logos de
 * empresas a las que se les cotizó una vez. Un crédito falso es la clase de
 * cosa que un comprador B2B verifica en un minuto — le escribe al supuesto
 * cliente — y cuando la descubre no se pierde el crédito, se pierde el resto
 * de la página.
 *
 * `instagram` es la cuenta DEL CLIENTE, no de Omega. Por eso no va nunca al
 * `sameAs` del schema de Omega: eso reclamaría la cuenta de otra empresa como
 * propia. Va como enlace de crédito, igual que se acredita a un cliente en un
 * portafolio impreso.
 *
 * `segmento` conecta el crédito con su página: en la de eventos se muestra el
 * cliente de eventos, no todos.
 */

export const CLIENTES = [
  {
    id: "baladi",
    nombre: "Baladi Samar Gourmet",
    rubro: "Catering y banquetería",
    trabajo: "Cobertura de evento: montaje, servicio, equipo y detalle de los platos",
    segmento: "eventos",
    instagram: "https://www.instagram.com/baladi.chile/",
    handle: "@baladi.chile",
  },
];

/** Clientes de un segmento, para su página. */
export const clientesDe = (segmentoId) =>
  CLIENTES.filter((cliente) => cliente.segmento === segmentoId);

export const hayClientes = () => CLIENTES.length > 0;
